import React, {
    useState,
    useEffect,
    useRef
} from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5000";

export default function ChatBot() {
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [isTyping, setIsTyping] = useState(false);
    const [messages, setMessages] = useState([
        {
            sender: "bot",
            text: "Hi 👋 How can I help you today?",
        },
    ]);
    const messagesEndRef = useRef(null);

    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({
            behavior: "smooth",
        });
    }, [messages, isTyping]);

    const sendMessage = async () => {
        if (!message.trim()) return;

        const userMessage = message;

        setMessages((prev) => [
            ...prev,
            {
                sender: "user",
                text: userMessage,
            },
        ]);

        setMessage("");

        try {
            setIsTyping(true);

            const res = await axios.post(`${API_BASE}/api/v1/chatbot`, {
                message: userMessage,
            });

            setTimeout(() => {

                setMessages((prev) => [
                    ...prev,
                    {
                        sender: "bot",
                        text:
                            res.data.answer === "NO_MATCH"
                                ? "Sorry, I couldn't find an answer."
                                : res.data.answer,

                        showWhatsapp:
                            res.data.answer === "NO_MATCH",
                    },
                ]);

                setIsTyping(false);

            }, 1000);

        } catch (error) {

            setIsTyping(false);

            setMessages((prev) => [
                ...prev,
                {
                    sender: "bot",
                    text: "Something went wrong.",
                },
            ]);
        }
    };

    return (
        <>
            {/* Chat Button */}

            <button
                onClick={() => setOpen(!open)}
                style={{
                    position: "fixed",
                    bottom: "90px",
                    right: "20px",
                    width: "53px",
                    height: "53px",
                    borderRadius: "50%",
                    border: "none",
                    cursor: "pointer",
                    background: "#4F46E5",
                    color: "#fff",
                    fontSize: "22px",
                    zIndex: 9999,

                    transition: "all .3s ease",

                    transform: open
                        ? "rotate(180deg)"
                        : "rotate(0deg)",

                    animation: open ? "none" : "pulse 2s infinite",
                }}
            >
                {open ? "✕" : "🤖"}
            </button>

            {/* Chat Window */}

            <div
                style={{
                    position: "fixed",
                    bottom: "160px",
                    right: "20px",
                    width: "350px",
                    height: "500px",
                    background: "#fff",
                    borderRadius: "12px",
                    boxShadow: "0 5px 20px rgba(0,0,0,.15)",
                    display: "flex",
                    flexDirection: "column",
                    zIndex: 9999,

                    transition:
                        "all .35s cubic-bezier(.34,1.56,.64,1)",

                    opacity: open ? 1 : 0,

                    transform: open
                        ? "translateY(0) scale(1)"
                        : "translateY(40px) scale(.9)",

                    pointerEvents: open
                        ? "auto"
                        : "none",
                }}
            >
                <div
                    style={{
                        padding: "15px",
                        background:
                            "linear-gradient(135deg,#4F46E5,#7C3AED)",

                        boxShadow:
                            "0 0 20px rgba(79,70,229,.5)",

                        animation:
                            "headerGlow 3s infinite alternate",
                        color: "#fff",
                        fontWeight: "bold",
                    }}
                >
                    SD Hub Assistant
                </div>

                <div
                    style={{
                        flex: 1,
                        overflowY: "auto",
                        padding: "10px",
                    }}
                >
                    {messages.map((msg, index) => (
                        <div
                            key={index}
                            style={{
                                textAlign:
                                    msg.sender === "user"
                                        ? "right"
                                        : "left",
                                marginBottom: "10px",
                            }}
                        >
                            <span
                                style={{
                                    display: "inline-block",
                                    padding: "8px 12px",
                                    borderRadius: "10px",
                                    background:
                                        msg.sender === "user"
                                            ? "#4F46E5"
                                            : "#f3f4f6",
                                    color:
                                        msg.sender === "user"
                                            ? "#fff"
                                            : "#000",
                                }}
                            >
                                <>
                                    {msg.text}

                                    {msg.showWhatsapp && (
                                        <div
                                            style={{
                                                marginTop: "10px",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    fontSize: "13px",
                                                    marginBottom: "8px",
                                                }}
                                            >
                                                Need help?
                                                <br />
                                                Chat with our team on WhatsApp.
                                            </div>

                                            <a
                                                href="https://wa.me/919154944461"
                                                target="_blank"
                                                rel="noreferrer"
                                                style={{
                                                    display: "inline-block",
                                                    padding: "8px 12px",
                                                    background: "#22c55e",
                                                    color: "#fff",
                                                    borderRadius: "8px",
                                                    textDecoration: "none",
                                                    fontWeight: "600",
                                                }}
                                            >
                                                WhatsApp Support
                                            </a>
                                        </div>
                                    )}
                                </>
                            </span>
                        </div>
                    ))}
                    {isTyping && (
                        <div
                            style={{
                                textAlign: "left",
                                marginBottom: "10px",
                            }}
                        >
                            <span
                                style={{
                                    display: "inline-block",
                                    padding: "8px 12px",
                                    borderRadius: "10px",
                                    background: "#f3f4f6",
                                }}
                            >
                                <div className="typing">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </span>
                        </div>
                    )}
                    <div ref={messagesEndRef} />
                </div>

                <div
                    style={{
                        display: "flex",
                        padding: "10px",
                        borderTop: "1px solid #ddd",
                    }}
                >
                    <input
                        type="text"
                        value={message}
                        onChange={(e) =>
                            setMessage(e.target.value)
                        }
                        placeholder="Ask a question..."
                        style={{
                            flex: 1,
                            padding: "10px",
                        }}
                        onKeyDown={(e) => {
                            if (e.key === "Enter")
                                sendMessage();
                        }}
                    />

                    <button
                        onClick={sendMessage}
                        style={{
                            marginLeft: "10px",
                            padding: "10px 15px",
                        }}
                    >
                        Send
                    </button>
                </div>
            </div>

            <style>{`
@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(79,70,229,.5);
  }

  70% {
    transform: scale(1.08);
    box-shadow: 0 0 0 15px rgba(79,70,229,0);
  }

  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(79,70,229,0);
  }
}

@keyframes headerGlow {
  from {
    box-shadow:
      0 0 10px rgba(79,70,229,.4);
  }

  to {
    box-shadow:
      0 0 25px rgba(124,58,237,.8);
  }
}

.typing {
  display: flex;
  gap: 4px;
}

.typing span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #666;
  animation: bounce 1.4s infinite;
}

.typing span:nth-child(2) {
  animation-delay: .2s;
}

.typing span:nth-child(3) {
  animation-delay: .4s;
}

@keyframes bounce {
  0%,80%,100% {
    transform: translateY(0);
    opacity: .5;
  }

  40% {
    transform: translateY(-6px);
    opacity: 1;
  }
}
`}</style>

        </>
    );
}